import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider, initI18n } from '@mypoz/i18n';

import { App } from './App.js';
import { captureTokenFromAddress, followOtherTabs } from '@/lib/session.js';
import '../index.css';

// MYP-125: the old website opens this app with `?token=…`. Taken out of the address before anything
// renders, so the router never sees it and it never stays in the history.
captureTokenFromAddress();
followOtherTabs();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root is missing from index.html');

// i18next is initialised before the first render, so no component ever sees a missing catalog
// and there is no translation flash on load.
void initI18n().then((i18n) => {
  createRoot(rootEl).render(
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </I18nextProvider>
    </StrictMode>,
  );
});
